// project imports
import { MenuItem } from 'types/menu';

// assets
import { FolderOutlined, FileTextOutlined } from '@ant-design/icons';
import { PERMISSIONS } from 'constants/permissions';

// icons
const icons = {
  FolderOutlined,
  FileTextOutlined
};

// ==============================|| MENU ITEMS - CONTENT ||============================== //

const content: MenuItem = {
  id: 'group-content',
  title: 'menu.content',
  type: 'group',
  children: [
    {
      id: 'article-categories',
      title: 'menu.articleCategories',
      type: 'item',
      url: '/article-categories',
      icon: icons.FolderOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.ARTICLE_CATEGORIES_VIEW
    },
    {
      id: 'articles',
      title: 'menu.articles',
      type: 'item',
      url: '/articles',
      icon: icons.FileTextOutlined,
      breadcrumbs: true,
      permission: PERMISSIONS.ARTICLES_VIEW
    }
  ]
};

export default content;
